import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// The library ships its styles as a single side-effect entry point.
import "@iicemeta/minecraft-react-ui/style.css";

import { App } from "./App";
import "./styles/site.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root not found");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
